// src/pages/Kontakt.tsx
import React, { useEffect } from 'react';
import { motion, Variants } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { CONTACT, SITE } from '../config';

const sectionVariant: Variants = {
  hidden: { opacity: 0, y: 12 },
  visible: (delay: number = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay, duration: 0.5, ease: 'easeOut' },
  }),
};

const Kontakt: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#f7f2ed] text-[#3f2b25]">
      <div className="max-w-6xl mx-auto py-12 px-6 lg:px-8">
        <motion.h1
          className="text-4xl md:text-5xl font-extrabold text-center text-[#4B2E2E] mb-10"
          initial="hidden"
          animate="visible"
          variants={sectionVariant}
          custom={0}
        >
          {t('contact.title')}
        </motion.h1>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Kontaktní informace */}
          <motion.div
            className="bg-white/90 backdrop-blur-md rounded-2xl p-8 shadow-lg ring-1 ring-[#4B2E2E]/10 flex flex-col gap-6"
            initial="hidden"
            animate="visible"
            variants={sectionVariant}
            custom={0.1}
          >
            <h2 className="text-2xl font-semibold text-[#4B2E2E]">{t('contact.info')}</h2>
            <div className="space-y-4 text-gray-700">
              <p>
                <span className="font-medium">{t('contact.address')}:</span>{' '}
                <span>{CONTACT.address}</span>
              </p>
              <p>
                <span className="font-medium">{t('contact.phone')}:</span>{' '}
                <a href={CONTACT.phoneLink} className="text-[#4B2E2E] hover:underline">
                  {CONTACT.phone}
                </a>
              </p>
              <p>
                <span className="font-medium">{t('contact.email')}:</span>{' '}
                <a href={CONTACT.emailLink} className="text-[#4B2E2E] hover:underline">
                  {CONTACT.email}
                </a>
              </p>
              <p>
                <span className="font-medium">{t('contact.website')}:</span>{' '}
                <a
                  href={SITE.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#4B2E2E] hover:underline"
                >
                  www.chalupalaura.cz
                </a>
              </p>
            </div>
            <div className="flex flex-wrap gap-4 mt-2">
              <a
                href={CONTACT.phoneLink}
                className="inline-flex items-center gap-2 bg-[#4B2E2E] text-white px-5 py-3 rounded-full font-semibold hover:brightness-105 transition"
              >
                {t('contact.call')}
              </a>
              <a
                href={CONTACT.emailLink}
                className="inline-flex items-center gap-2 border border-[#4B2E2E] text-[#4B2E2E] px-5 py-3 rounded-full font-medium hover:bg-[#e8e3dd] transition"
              >
                {t('contact.writeEmail')}
              </a>
            </div>
          </motion.div>

          {/* Mapa */}
          <motion.div
            className="bg-white/90 backdrop-blur-md rounded-2xl p-8 shadow-lg ring-1 ring-[#4B2E2E]/10 flex flex-col gap-6"
            initial="hidden"
            animate="visible"
            variants={sectionVariant}
            custom={0.2}
          >
            <h2 className="text-2xl font-semibold text-[#4B2E2E]">{t('contact.mapTitle')}</h2>
            <div className="w-full h-96 rounded-xl overflow-hidden border border-[#d9c2a0]">
              <iframe
                title="Mapa Chalupa Laura"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d899.6741852945433!2d12.504111576274742!3d50.37284052842965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a0c22932f11247%3A0xfcde323d694c75da!2sBublava%20327%2C%20358%2001%20Bublava%2C%20%C4%8Cesko!5e0!3m2!1scs!2ssk!4v1746428826365!5m2!1scs!2ssk"
                className="w-full h-full"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <p className="text-sm text-gray-600">
              {t('contact.mapNote')}
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Kontakt;
